// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-l_fc","catalogByServiceItem__title":"c-l_fe"};